export default __webpack_public_path__ + "static/media/art-slt-1.7fe87400.png";